import { render } from "./search_page.vue?vue&type=template&id=3beee436"
import script from "./search_page.vue?vue&type=script&lang=js"
export * from "./search_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__